import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {
  AppointmentSystemAdmin,
  AppointmentSystemAdminCreateRequest,
  AppointmentSystemAdminCreateResponse,
  AppointmentSystemAdminDetails,
  AppointmentSystemAdminUpdateRequest,
  AppointmentSystemAdminUpdateResponse
} from '@ms-organization-entities';
import {PriorityPatchRequest, SystemAdminDependency} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from "../interface/data-protection-governance-service";
import {UserResource} from "it/primatoo/openapi/api/org/schemas/userresource/UserResource";


@Injectable({
  providedIn: 'root'
})

export class AppointmentsSystemAdminService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient) {
    super(httpClient)
    this.endpoint = this.config.endPoint + '/api/org/appointments-system-admin/';
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

  public delete(id: number): Observable<void> {
    const url = this.getEndPointV1() + `${id}/`;
    return this.httpClient.delete<void>(url);
  }

  public deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    const url = this.getEndPointV1() + `by-ids`;
    return this.httpClient.request<{ failed: number[] }>('DELETE', url, {body: {ids}})
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<any> {
    return undefined;
  }

  getAppointmentsSystemAdmin(): Observable<AppointmentSystemAdmin[]> {
    const url = this.endpoint;
    return this.httpClient.get<AppointmentSystemAdmin[]>(url);
  }

  getAppointmentsSystemAdminCandidates(): Observable<UserResource[]> {
    const url = this.endpoint + 'candidate';
    return this.httpClient.get<UserResource[]>(url);
  }


  create(appointmentSystemAdminCreateRequest: AppointmentSystemAdminCreateRequest): Observable<AppointmentSystemAdminCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<AppointmentSystemAdminCreateResponse>(url, appointmentSystemAdminCreateRequest);
  }

  createMultiple(request: { userResourceIds: number[] }): Observable<any> {
    const url = this.endpoint + 'multiple';
    return this.httpClient.post<any>(url, {userResourceIds: request.userResourceIds});
  }

  getById(appointmentId: number): Observable<AppointmentSystemAdmin> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.get<AppointmentSystemAdmin>(url);
  }

  getDetails(appointmentId: number): Observable<AppointmentSystemAdminDetails> {
    const url = this.endpoint + `${appointmentId}/details`;
    return this.httpClient.get<AppointmentSystemAdminDetails>(url);
  }

  getDependency(appointmentId: number): Observable<SystemAdminDependency> {
    const url = this.endpoint + `${appointmentId}/dependency`;
    return this.httpClient.get<SystemAdminDependency>(url);
  }

  update(appointmentId: number, appointmentSystemAdminUpdateRequest: AppointmentSystemAdminUpdateRequest): Observable<AppointmentSystemAdminUpdateResponse> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.put<AppointmentSystemAdminUpdateResponse>(url, appointmentSystemAdminUpdateRequest);
  }


}
